import { render, staticRenderFns } from "./export-folder.vue?vue&type=template&id=6dd57f3a&scoped=true"
import script from "./export-folder.vue?vue&type=script&lang=ts"
export * from "./export-folder.vue?vue&type=script&lang=ts"
import style0 from "./export-folder.vue?vue&type=style&index=0&id=6dd57f3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd57f3a",
  null
  
)

export default component.exports